module.exports = __webpack_public_path__ + "static/media/img-promotional-message-0@3x.ac70e1df.png";